import { __decorate, __metadata, __param } from "tslib";
import { E_BusinessMode } from '@/apis/service/PackageApi.types';
import { E_AccountType, E_UserStatus } from '@/apis/service/types';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import _ from 'lodash';
let ServiceAccountQueries = class ServiceAccountQueries {
    constructor(miscApi, packageApi, productApi, companyApi, productService, accountApi) {
        this.miscApi = miscApi;
        this.packageApi = packageApi;
        this.productApi = productApi;
        this.companyApi = companyApi;
        this.productService = productService;
        this.accountApi = accountApi;
        this.fullLangSystemCodeName = {
            cn: 'zh_CN',
            en: 'en_US',
        };
        this.fullLangPackageName = {
            cn: 'package_name',
            en: 'en_name',
        };
        this.fullLangProductsName = {
            cn: 'alias_cn',
            en: 'alias_en',
        };
    }
    getAccountStatuses() {
        const neededStatus = [
            E_UserStatus.ACTIVE,
            E_UserStatus.PENDING,
            E_UserStatus.BLOCKED
        ];
        return this.miscApi.getSystemCodes('ACCOUNT_STATUS').then(data => {
            return _.filter(data, item => {
                return neededStatus.includes(item.system_code);
            });
        });
    }
    getPaidTypes() {
        return [
            E_AccountType.STANDARD,
            E_AccountType.COOPERATIVE,
            E_AccountType.TRIAL,
            E_AccountType.NOT_RENEW,
            E_AccountType.FREE,
            E_AccountType.INTERNAL
        ];
    }
    getPackages() {
        return this.packageApi.getPackageInfoList();
    }
    getCompanies(params) {
        return this.companyApi.getQueryCompanies(params);
    }
    async getProducts() {
        const products = await this.productService.getProductionProducts();
        return products;
    }
    async getCompanyPackageAndProduct(company_id) {
        const { products, packages } = await this.companyApi.getCompanyPackageAndProduct(company_id);
        return {
            products,
            packages,
            accountPackages: _.filter(packages, item => this.hasPackageBusinessMode(item, E_BusinessMode.SEATS)),
            creditPackages: _.filter(packages, item => this.hasPackageBusinessMode(item, E_BusinessMode.CREDITS)),
        };
    }
    hasPackageBusinessMode(item, mode) {
        return _.includes(_.map(_.split(item.business_mode || '', ','), _.trim), mode);
    }
    async getTenantUsersList(account) {
        const data = await this.accountApi.getTenantUsersList(account);
        return data;
    }
    getListAccountByWildcardQuery(queryString) {
        return this.accountApi.getListAccounts({
            s_email: queryString,
            sEcho: 1,
            iDisplayLength: 20,
            iDisplayStart: 0,
        }).then(res => {
            return res.aaData;
        });
    }
    getCompanyListAccountByWildcardQuery(companyId, queryString) {
        return this.accountApi.getListAccounts({
            s_company_id: companyId,
            s_identifiers: queryString,
            sEcho: 1,
            iDisplayLength: 20,
            iDisplayStart: 0,
        }).then(res => {
            return res.aaData;
        });
    }
};
ServiceAccountQueries = __decorate([
    injectable(),
    __param(0, inject(Symbols.MiscApi)),
    __param(1, inject(Symbols.PackageApi)),
    __param(2, inject(Symbols.ProductApi)),
    __param(3, inject(Symbols.CompanyApi)),
    __param(4, inject(Symbols.ProductService)),
    __param(5, inject(Symbols.AccountApi)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])
], ServiceAccountQueries);
export { ServiceAccountQueries };
